export default "__VITE_ASSET__Cdw$flnH__"